// Cadastro estrangeiro (Locatário, Fiador, Proprietário, Sócio...): documento estrangeiro
// (tipo + número + país emissor). Com o flag ligado, basta um dos dois: CPF/CNPJ
// brasileiro (validado normalmente) OU o documento estrangeiro. Não há consulta à Receita
// quando não há CNPJ.

export const TIPOS_DOCUMENTO_ESTRANGEIRO = [
  { valor: "PASSAPORTE", label: "Passaporte" },
  { valor: "RNE/RNM", label: "RNE / RNM" },
  { valor: "DOCUMENTO EMPRESA ESTRANGEIRA", label: "Documento estrangeiro de empresa" },
  { valor: "OUTRO", label: "Outro" },
];

export const DOCUMENTO_ESTRANGEIRO_VAZIO = {
  estrangeiro: false,
  documentoEstrangeiroTipo: "",
  documentoEstrangeiroNumero: "",
  documentoEstrangeiroPais: "",
};

// Número livre: letras (maiúsculas), números e separadores comuns ( - . / ).
export const limparNumeroEstrangeiro = (valor) =>
  String(valor ?? "")
    .toUpperCase()
    .replace(/[^0-9A-Z\-./ ]/g, "")
    .replace(/\s{2,}/g, " ")
    .slice(0, 50);

export const limparPaisEstrangeiro = (valor) =>
  String(valor ?? "")
    .toLocaleUpperCase("pt-BR")
    .slice(0, 100);

export const labelTipoDocumentoEstrangeiro = (valor) => TIPOS_DOCUMENTO_ESTRANGEIRO.find((t) => t.valor === valor)?.label || valor || "Documento estrangeiro";

// Texto para listas, impressões e documentos: "Passaporte nº AB123456 (ARGENTINA)".
export function descreverDocumentoEstrangeiro(registro) {
  if (!registro?.estrangeiro || !registro.documentoEstrangeiroNumero) return "";
  const pais = registro.documentoEstrangeiroPais ? ` (${registro.documentoEstrangeiroPais})` : "";
  return `${labelTipoDocumentoEstrangeiro(registro.documentoEstrangeiroTipo)} nº ${registro.documentoEstrangeiroNumero}${pais}`;
}

// Erros dos campos do documento estrangeiro (objeto vazio = ok).
// Se o estrangeiro tiver CPF/CNPJ brasileiro (`temDocumentoNacional`), o documento
// estrangeiro é opcional; mas, se algum campo dele for preenchido, os três passam a valer.
export function validarDocumentoEstrangeiro(registro, { temDocumentoNacional = false } = {}) {
  const erros = {};
  if (!registro?.estrangeiro) return erros;
  const tipo = registro.documentoEstrangeiroTipo;
  const numero = String(registro.documentoEstrangeiroNumero || "").trim();
  const pais = String(registro.documentoEstrangeiroPais || "").trim();
  if (temDocumentoNacional && !tipo && !numero && !pais) return erros;
  if (!tipo) erros.documentoEstrangeiroTipo = "Informe o tipo do documento estrangeiro.";
  if (!numero)
    erros.documentoEstrangeiroNumero = temDocumentoNacional
      ? "Informe o número do documento estrangeiro."
      : "Informe o CPF/CNPJ ou o número do documento estrangeiro.";
  if (!pais) erros.documentoEstrangeiroPais = "Informe o país emissor.";
  return erros;
}

// Campos para enviar ao backend (limpa os dados quando o flag está desmarcado).
export function camposDocumentoEstrangeiro(registro) {
  if (!registro?.estrangeiro) return { ...DOCUMENTO_ESTRANGEIRO_VAZIO };
  return {
    estrangeiro: true,
    documentoEstrangeiroTipo: registro.documentoEstrangeiroTipo || "",
    documentoEstrangeiroNumero: limparNumeroEstrangeiro(registro.documentoEstrangeiroNumero).trim(),
    documentoEstrangeiroPais: limparPaisEstrangeiro(registro.documentoEstrangeiroPais).trim(),
  };
}

// Nome do flag conforme o papel/cadastro: "Locatário estrangeiro", "Fiador estrangeiro"...
const ROTULO_PAPEL = { Locataria: "Locatário", Locadora: "Locador", Fiador: "Fiador" };
export const rotuloEstrangeiro = (papel) => `${ROTULO_PAPEL[papel] || papel || ""} estrangeiro`.trim().replace(/^estrangeiro$/, "Estrangeiro");
